import GET_ARTICLES from "../plugins/getArticles"

const [ w, d, content ] = [ window, document, 'works' ]

const init = () => {
  if( w.query_string('cat') ) {
    $('.element_list .list_title1').remove()
  }
  $('.contents .wrapLink','.element_list').each( (i,obj) => {
    let href = obj.getAttribute('href')
    let thumb = obj.querySelector('.thum_img > img').getAttribute('src')
    let is_new = obj.querySelectorAll('span.new').length > 0 ? true: false
    let catObj = obj.querySelector('.catetitle a')
    let cat = catObj? catObj.innerText : ''
    let title = obj.querySelector('h5 > a').getAttribute('title')
    let desc = obj.querySelector('p.catch').innerText
    let $item = $(`
      <a href="${href}" class="${content}-item">
        <figure class="${content}-item__img">
          <div class="${content}-item__img-cover" style="background-image:url(${thumb})"><img src="${thumb}" alt="${title}" width=""></div>
        </figure>
        <div class="${content}-item__body">
          ${cat ? `<span class="cate">${cat}</span>`: ''}
          <h4 class="subject">
            ${title} ${is_new ? '<span class="new">NEW</span>': ''}
          </h4>
        </div>
      </a>`)
    $(obj).replaceWith( $item )
  })

  // カテゴリリスト追加
  const $categorylist = $(`<div class="${content}-catlist__wrap">`).attr('data-plugin','getCatList')
  $('#main > .element_list').before( $categorylist.clone(true) )
  $('#main > .element_list').after( $categorylist.clone(true) )
  $('#main > .element_detail').after( $categorylist.clone(true) )
  $('[data-plugin="getCatList"]').getCatList({
    content,
    blockClass: `${content}-catlist`,
    addAll: true,
    method: 'append'
  })

  // 詳細書き換え
  if( d.body.classList.contains('is--detail') ){
    
    let catname = d.querySelector('.title .catetitle').innerText
    let title = d.querySelector('.hs_entrytitle').innerText
    let $detailHead = $(`
      <div class="${content}-detailHead">
        <span class="${content}-detailHead__catname button button-secondary button-xsmall">${catname}</span>
        <h3 class="${content}-detail-title">${title}</h3>
      </div>
    `)
    let $newItem = $(`
      <section class="${content}-detail-block">
        <div class="block-recommend__list" data-plugin="getArticles" data-content="recommendation" data-amount="4">
          <p class="text-center padding-xlarge" style="width: 100%">Loading...</p>
        </div>
        <!-- /.block-recommend__list -->
      </section>
    `)
    let makeItem = item => $(`
      <a href="${item.href}" class="${content}-item">
        <figure class="${content}-item__img">
          <div class="${content}-item__img-cover"><img src="${item.thumb}" alt="${item.title}" width=""></div>
        </figure>
        <div class="${content}-item__body">
          ${item.is_new ? '<span class="new">NEW</span>': ''}
          <span class="cat">${item.category.name}</span>
          <h4 class="name">${item.title}</h4>
          <p class="desc">${item.desc}</p>
        </div>
      </a>
    `)[0]
    $('.element_detail .hs_entrytitle').remove()
    $('.element_detail > .title').replaceWith( $detailHead )
    $('.element_detail').after( $newItem )
    GET_ARTICLES('[data-plugin="getArticles"]',{ makeItem })

  }
}

export default function WORKS () {
  $(() => init())
}